import { inject, observer } from 'mobx-react'
import React, { ChangeEvent } from 'react'
import { RouteComponentProps } from 'react-router'
import { withStateCard, TutorialButtonAndBackButton, Toast, ToastType } from '../../Components';
import { PreProjetoStore, PREPROJETO_STORE, ProfessorModel, ProfessorStore, PROFESSOR_STORE, SituacaoDoPreProjeto } from '../../Store'
import DetalhesPreProjeto from './Components/DetalhesPreProjeto';
import Tutorial_Funcionario from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Funcionario.pdf";
import { GlobalErrorToast } from '../Shared/GlobalErrorToast';

interface IProps extends RouteComponentProps<{ id: string }> {
    [PREPROJETO_STORE]: PreProjetoStore;
    [PROFESSOR_STORE]: ProfessorStore
}

const Container: React.FC = (props: React.HTMLAttributes<HTMLDivElement>) => <>{props.children}</>;
const DetalhesPreProjetoPageWithState = withStateCard(Container);

@inject(PREPROJETO_STORE, PROFESSOR_STORE)
@observer
export default class PreProjetoPage extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    onResumeClick = () => {
        window.open(Tutorial_Funcionario);
    }

    componentDidMount() {
        const preProjetoStore = this.props[PREPROJETO_STORE]
        const professorStore = this.props[PROFESSOR_STORE]
        const { match } = this.props

        preProjetoStore.buscarPreProjetoFuncionario(parseInt(match.params.id))
        professorStore.getProfessores()
    }

    handleOrientadoresSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const id = Number(e.target.value)
        const professorStore = this.props[PROFESSOR_STORE];
        const { professores } = professorStore;
        const preProjetoStore = this.props[PREPROJETO_STORE]

        preProjetoStore.updateAttribute('vagasRestantes', 0)

        if (id == 0) {
            preProjetoStore.updateAttribute('orientador', new ProfessorModel())
        } else {
            preProjetoStore.updateAttribute('orientador', professores.find(p => p.id == id))
            preProjetoStore.getVagasRestantesProfessor(id)
        }
    }

    aprovarPreProjeto = async (preProjetoId: number, professorId: number) => {
        const preProjetoStore = this.props[PREPROJETO_STORE];
        const { setValidationError } = preProjetoStore
        const { match } = this.props

        setValidationError({});
        await preProjetoStore.ppAprovarFuncionario(preProjetoId, professorId)

        preProjetoStore.buscarPreProjetoFuncionario(parseInt(match.params.id));
    }

    render() {
        const preProjetoStore = this.props[PREPROJETO_STORE]
        const professorStore = this.props[PROFESSOR_STORE]
        const { preProjeto, preProjetoState, orientador, preProjetoValidationError, vagasRestantes } = preProjetoStore;
        const { professores, professoresState } = professorStore
        const { history } = this.props;

        return (
            <DetalhesPreProjetoPageWithState
                state={preProjetoState && professoresState}
                loading='Carregando...'
            >
                <TutorialButtonAndBackButton
                    openTutorial={this.onResumeClick}
                    voltar={() => history.push('/funcionario')}
                />
                <GlobalErrorToast messages={preProjetoValidationError && preProjetoValidationError.global} />
                {preProjeto && preProjeto.situacao == SituacaoDoPreProjeto.aprovado &&
                    <Toast type={ToastType.success}><b>Orientação aceita</b></Toast>
                }
                {preProjeto && preProjeto.situacao == SituacaoDoPreProjeto.pendente &&
                    <Toast type={ToastType.warning}><b>Seleção pendente</b></Toast>
                }
                {preProjeto && preProjeto.situacao == SituacaoDoPreProjeto.recusado &&
                    <Toast type={ToastType.error}><b>Orientação não aceita</b></Toast>
                }
                <DetalhesPreProjeto
                    preprojeto={preProjeto}
                    professores={professores}
                    onSelectChange={this.handleOrientadoresSelectChange}
                    orientador={orientador}
                    onAprovar={this.aprovarPreProjeto}
                    vagas={vagasRestantes}
                />
            </DetalhesPreProjetoPageWithState>
        )
    }
}